import { Utils } from 'choerodon-ui/dataset';
const isSameLike = Utils.isSameLike;
export default isSameLike;
